import { useState } from "react";
import { Button, Input, InputGroup, InputGroupAddon, Label } from "reactstrap";
import { copyToClipboard } from "utils/copyToClipboard";
import "assets/styles/components/form.scss";

export const CopyToClipboard = ({ label, t, btnTitle, code }: any) => {
  const [copy, setCopy] = useState(code);
  return (
    <InputGroup className="position-relative">
      <div className="form-floating ">
        <Input
          value={copy}
          type="text"
          id={"name"}
          className="border-radius-1 fs-8 text-end  "
          onChange={(e) => {
            setCopy(e.target.value);
          }}
        />
        <Label className="text-end fs-10 " for={"name"}>
          {label}
        </Label>
      </div>
      <InputGroupAddon
        addonType="prepend"
        className="position-absolute px-2"
        style={{
          top: 8,
        }}
      >
        <Button
          onClick={() => copyToClipboard(copy)}
          size="xs"
          color="warning border-radius-1 py-2"
        >
          {btnTitle ? btnTitle : t("Copy")}
        </Button>
      </InputGroupAddon>
    </InputGroup>
  );
};
